import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.402 5.975c0-.124.1-.225.225-.225h7.364a3.26 3.26 0 0 1 3.25 3.26v7.38H8.124a1.86 1.86 0 0 1 0 1.5h9.177a1.85 1.85 0 0 1 0-1.5h-.56V9.76h2.122c.484 0 .925.28 1.131.719l1.132 2.41c.078.167.118.348.118.532v1.718c0 .462-.25.865-.622 1.081a1.85 1.85 0 0 1 .128 1.564 2.75 2.75 0 0 0 1.994-2.645v-1.718a2.75 2.75 0 0 0-.26-1.169l-1.132-2.41a2.75 2.75 0 0 0-2.49-1.583h-2.18a4.76 4.76 0 0 0-4.691-4.009H4.627c-.953 0-1.725.772-1.725 1.725a.75.75 0 1 0 1.5 0m.315 11.914a1.85 1.85 0 0 1 0-1.5h-.2a1.487 1.487 0 0 1-1.488-1.487.75.75 0 0 0-1.5 0 2.987 2.987 0 0 0 2.987 2.987zM2.784 7.15a.75.75 0 0 0 0 1.5H6.44a.75.75 0 0 0 0-1.5zM1.6 9.2a.75.75 0 0 0 0 1.5h3.234a.75.75 0 0 0 0-1.5zm.673 2.049a.75.75 0 0 0 0 1.5h1.95a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.282 17.14a1.86 1.86 0 1 1-3.722 0 1.86 1.86 0 0 1 3.722 0M20.865 17.14a1.86 1.86 0 1 1-3.722 0 1.86 1.86 0 0 1 3.722 0"
    }, null, -1)
  ]))]))
}
export default { render: render }